module.exports = __webpack_public_path__ + "m4a/lose.m4a?48582af6dbd095494c1b5bd1ee7d4afc";